/*
 * YblMinKyc actions
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  clearDefaultError, rootApiResponse,
} from '../HeaderContainer/actions';
import { utils } from '../../devUtils';
import { errorResponse, successResponse } from '../../devUtils/commonUtils';
import { DEFAULT_ACTION, PAY_BALANCE_CONSTANT } from '../PayBalance/constants';
import { YBL_KYC_STATIC_DATA } from './constants';

const yesBankMinKycSuccess = (payload) => ({ type: PAY_BALANCE_CONSTANT.FETCH_YBL_MIN_KYC, payload });
const yblKycStaticDataSuccess = (payload) => ({ type: YBL_KYC_STATIC_DATA, payload });

const yesBankMinKyc = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const res = await reqHandler.postHandler(api, endpoint.POST_YESBANK_MIN_KYC, payload, authPrerequist);
    if (res && res.status) {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, res)));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      dispatch(yesBankMinKycSuccess(res));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw res.message;
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const kycStaticData = () => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const res = await reqHandler.getHandler(api, endpoint.GET_KYC_STATIC_DATA, {}, authPrerequist);
    if (res && res.status) {
      dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, res)));
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(yblKycStaticDataSuccess(res));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw res.message;
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

export {
  yesBankMinKyc,
  kycStaticData,
};



// WEBPACK FOOTER //
// client/containers/YblMinKyc/actions.js